import { bindDialog } from './dialog.mjs';

/** Keep navigation and native focus restoration in step with the panel's exit. */
export const initMobileMenu = (menu, triggers, { navigate } = {}) => {
    const controller = bindDialog(menu, triggers, { closeAnimation: 'ovalia-menu-exit' });
    if (!controller) return null;

    const win = menu.ownerDocument.defaultView;
    const follow = navigate || ((url) => win.location.assign(url));
    let destination = null;

    menu.querySelectorAll('.HeaderNav__item').forEach((item, index) => {
        // Extra CMS entries never make the opening sequence progressively slower.
        item.style.setProperty('--menu-item-index', Math.min(index, 5));
    });

    menu.addEventListener('close', () => {
        const url = destination;
        destination = null;
        if (url) follow(url);
    });
    menu.addEventListener('click', (event) => {
        const link = event.target.closest?.('a[href]');
        if (!link || event.defaultPrevented || event.button !== 0
            || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
            || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;

        event.preventDefault();
        if (!menu.open || menu.classList.contains('is-closing')) return;
        destination = link.href;
        controller.close();
    });

    // Use the same breakpoint as the header layout; a missing stylesheet must not break closing.
    const breakpoint = win.getComputedStyle(menu.ownerDocument.documentElement)
        .getPropertyValue('--ov-navigation-breakpoint').trim();
    if (breakpoint) {
        win.matchMedia(`(min-width: ${breakpoint})`).addEventListener('change', ({ matches }) => {
            if (matches && menu.open) controller.close();
        });
    }

    return controller;
};
